export default "__VITE_PUBLIC_ASSET__51eeb333__"